import { useNavigate, NavigateFunction, NavigateOptions, To } from 'react-router-dom';
import { appStore } from '@store';

const defaultParamsNames = [
	'utm_source',
	'utm_campaign',
	'utm_medium',
	'utm_term',
	'utm_content',
	'fbp',
	'fbc',
];

const locationProvider = (): Location => {
	return appStore.sourceLocation ?? window.location;
};

const preparePreservedSearch = (
	location: Location,
	paramsNames: string[] = defaultParamsNames,
): string => {
	const url = new URL(location.href);
	// Array.from(url.searchParams.keys()).forEach(key => {
	// 	if (!paramsNames.includes(key)) url.searchParams.delete(key);
	// });
	return url.search;
};

export const getPreservedSearchRoute = (
	pathname: string,
	getLocation: () => Location = locationProvider,
	paramsNames: string[] = defaultParamsNames,
): To => {
	const location = getLocation();
	const search = preparePreservedSearch(location, paramsNames);
	const to = { pathname, search };
	return to;
};

export const useNavigateWithSearchParams = (
	getLocation: () => Location = locationProvider,
	paramsNames: string[] = defaultParamsNames,
): NavigateFunction => {
	const navigate = useNavigate();

	// (to: To, options?: NavigateOptions): void;
	// (delta: number): void;
	const attributedNavigate = (param: To | number, options?: NavigateOptions): void => {
		if (typeof param === 'number') {
			navigate(param);
		} else if (typeof param === 'string') {
			const to: To = getPreservedSearchRoute(param, getLocation, paramsNames);
			navigate(to, options);
		} else {
			navigate(param, options);
		}
	};

	return attributedNavigate;
};
